module.exports = __webpack_public_path__ + "img/navbar_background.97d9ffed.svg";